/**
 * Bearer token for calculator API calls. Uses the ID token: Auth0 access
 * tokens scoped to a custom API audience don't carry email/name/
 * email_verified claims (LOOPLAT-205), but the ID token does, and the
 * backend accepts it (auth.Verifier's client-id verifier). Still calls
 * getAccessTokenSilently first — even though its return value is unused —
 * because that's what triggers Auth0's silent session renewal, which also
 * refreshes the cached ID token as a side effect.
 */
export async function getApiBearerToken({ getAccessTokenSilently, getIdTokenClaims, audience }) {
  const authorizationParams = {
    scope: 'openid profile email',
    ...(audience ? { audience } : {}),
  };

  try {
    await getAccessTokenSilently({ authorizationParams });
  } catch {
    // Fall through — try whatever ID token claims are already cached.
  }

  const idClaims = await getIdTokenClaims();
  const idRaw = idClaims && typeof idClaims.__raw === 'string' ? idClaims.__raw : '';
  if (idRaw) return idRaw;

  throw new Error('no_bearer_token');
}
